export default __webpack_public_path__ + "static/media/feedback-icon.47dcfa27.svg";